import Datatable from "./datatable_controller";

// Connects to data-controller="organization-datatable"
export default class extends Datatable {
  static targets = ['filter', 'statusFilter']

  connect() {
    super.connect()
    this.selectedStatuses = []
  }

  get columns() {
    let table_columns = [
      {data: 'name'},
      {data: 'created_date'},
      {data: 'events_created'},
      {data: 'team_size'},
      {data: 'status'}
    ]
    return table_columns
  }

  get searching() {
    return true
  }

  get ordering() {
    return false
  }

  get lengthChange() {
    return false
  }

  manipulateData(data) {
    data = super.manipulateData(data)
    
    if (this.selectedStatuses && this.selectedStatuses.length > 0) {
      data.status_filters = this.selectedStatuses.join(',')
    }
    
    return data
  }

  applyStatusFilter(event) {
    this.handleEvent(event)
    this.collectSelectedStatuses()
    this.reloadDataTable()
    this.closeDropdown(event)
  }

  removeStatusFilter(event) {
    this.handleEvent(event)
    this.clearStatusFilters()
    this.reloadDataTable()
    this.closeDropdown(event)
  }

  // Private helper methods
  handleEvent(event) {
    event.preventDefault()
    event.stopPropagation()
  }

  collectSelectedStatuses() {
    this.selectedStatuses = []
    
    if (this.hasStatusFilterTarget) {
      this.statusFilterTargets.forEach(checkbox => {
        if (checkbox.checked) {
          this.selectedStatuses.push(checkbox.value)
        }
      })
    }
  }

  clearStatusFilters() {
    this.selectedStatuses = []
    
    if (this.hasStatusFilterTarget) {
      this.statusFilterTargets.forEach(checkbox => {
        checkbox.checked = false
      })
    }
  }

  reloadDataTable() {
    if (this.dataTable) {
      this.dataTable.ajax.reload()
    }
  }

  closeDropdown(event) {
    const dropdownMenu = event.target.closest('.dropdown-menu')
    const dropdownToggle = event.target.closest('.dropdown')?.querySelector('[data-bs-toggle="dropdown"]')
    
    if (dropdownMenu) {
      dropdownMenu.classList.remove('show')
    }
    if (dropdownToggle) {
      dropdownToggle.setAttribute('aria-expanded', 'false')
    }
  }
}
